
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.257 2.824l11.954 23.91H3.302l11.955-23.91zM6.082 25.016h18.35l-9.175-18.35-9.175 18.35z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.52 16.942l-.773-.773-2.49 2.49-2.491-2.49-.773.773 2.49 2.49-2.49 2.492.773.773 2.49-2.491 2.491 2.49.773-.773-2.49-2.49 2.49-2.491z","fill":"#fff"}})])
          )
        }
      }
    